var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "table-container" },
    [
      _c(
        "div",
        {
          staticClass:
            "flex items-center gap-2 wraningBorder flex-wrap text-black/88",
        },
        [
          _c(
            "div",
            { staticClass: "flex gap-2 items-center" },
            [
              _c("InfoCircleFilled"),
              _vm._v(
                "Visit check-ins open 10 minutes before the scheduled start time and are considered late if not completed within 5 minutes after that time. "
              ),
            ],
            1
          ),
        ]
      ),
      _c("p", { staticClass: "font-semibold mb-5 InProgressTasks titleTab" }, [
        _vm._v("Current Visits"),
      ]),
      _c(
        "div",
        {
          staticClass:
            "bg-indigo-50 flex justify-between items-center py-3 px-4 text-sm rounded-lg mb-5",
        },
        [
          _c(
            "div",
            { staticClass: "flex items-center gap-2 flex-wrap text-black/88" },
            [
              _c(
                "div",
                { staticClass: "flex gap-2 items-center text-sm" },
                [
                  _c("InfoCircleFilled"),
                  _vm._v(
                    "Want to see everything on a weekly basis? Go to the "
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "text-blue ml-1 cursor-pointer inline-flex items-center gap-2",
                  on: { click: _vm.handleListToggle },
                },
                [
                  _c("HoveredIcon", { staticClass: "w-3 h-3 hover-icon" }),
                  _vm._v("Scheduler View "),
                ],
                1
              ),
            ]
          ),
        ]
      ),
      _c(
        "LoadingOverlay",
        { attrs: { loading: _vm.isActivitiesLoaded, hasData: !_vm.isLoading } },
        [
          _c(
            "div",
            { staticClass: "flex flex-col items-top gap-4 sm:flex-row" },
            [
              _c(
                "FormGroup",
                [
                  _c("ContractorsMultiselect", {
                    attrs: {
                      value: _vm.contractorsIdsActive,
                      getParentcontainerStyle: "customWidthMax smallHeight",
                      placeholder: "Search by assignee",
                      contractorsConditions:
                        _vm.contractorsMultiselectConditions,
                      debounceTime: 1000,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.updateContractorsFilter($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isEmpty && _vm.activitiesActive.length > 0
            ? [
                _c("div", { staticClass: "overflow-scroll" }, [
                  _c(
                    "table",
                    {
                      staticClass:
                        "relative w-full text-sm font-normal text-left mt-6 dark:text-gray-400 tableParent",
                    },
                    [
                      _c(
                        "thead",
                        {
                          staticClass:
                            "text-m text-black customBackground InProgressBack",
                        },
                        [_c("TableHeaders")],
                        1
                      ),
                      _vm._l(_vm.activitiesActive, function (activity) {
                        return _c("ManagementActivityCard", {
                          key: activity.id,
                          attrs: {
                            activity: activity,
                            project: activity.project,
                            redirectToContractor: true,
                            frozen: activity.project.completed,
                            currentUserId: _vm.currentUser.id,
                            currentUserRole: _vm.currentUser.role,
                            currentUser: _vm.currentUser,
                            companyId: _vm.companyId,
                          },
                          on: {
                            activityAdded: _vm.onActivityListItemsChanged,
                            activityDeleted: _vm.onActivityListItemsChanged,
                            activityUpdated: _vm.onActivityListItemsChanged,
                            activityCompleted: _vm.onActivityListItemsChanged,
                            activityCancelled: _vm.onActivityListItemsChanged,
                            activityReopened: _vm.onActivityListItemsChanged,
                          },
                          scopedSlots: _vm._u(
                            [
                              _vm.isManager
                                ? {
                                    key: "firstActionsItem",
                                    fn: function () {
                                      return [
                                        _c("ActivityCustomRequest", {
                                          attrs: {
                                            companyId: _vm.companyId,
                                            currentUserId: _vm.currentUser.id,
                                            projectActivity: activity,
                                            projectSkills:
                                              _vm.project.project_skills,
                                          },
                                          on: {
                                            customRequestCreated:
                                              _vm.onActivityListItemsChanged,
                                            customRequestUpdated:
                                              _vm.onActivityListItemsChanged,
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  }
                                : null,
                            ],
                            null,
                            true
                          ),
                        })
                      }),
                    ],
                    2
                  ),
                ]),
                _c("CardPagination", {
                  staticClass: "mt-4",
                  attrs: { config: _vm.paginationConfig },
                  on: {
                    "update:config": [
                      function ($event) {
                        _vm.paginationConfig = $event
                      },
                      function ($event) {
                        return _vm.handlePaginationEvent($event)
                      },
                    ],
                  },
                }),
              ]
            : [
                _c("EmptyListPlaceholder", {
                  attrs: { title: "You currently have no current visits" },
                }),
              ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }